// "?" → "_": the backend still reads an encoded %3F as a query start and loses the extension.
export const toUploadPathSegment = (fileName: string): string =>
  encodeURIComponent(fileName.replaceAll("?", "_"));
